import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

/**
 * BA Battery & Tyre (South Africa, babattery.co.za) — standalone deep-cycle
 * storage batteries for UPS / inverter / solar (load-shedding backup), as
 * opposed to the small alarm-panel standby cells already in the catalog.
 * Specs are from the vendor product pages; physical dimensions / terminal
 * style are not published there, so they are left off.
 */
export const BA_BATTERY_CATALOG: EquipmentCatalogEntry[] = [
  {
    id: 'ba-gel-deep-cycle-100ah-12v',
    manufacturer: 'BA Battery',
    model: 'BA Gel Deep Cycle 100Ah 12V',
    category: 'battery',
    tagline: '12 V 100 Ah gel deep-cycle — UPS, inverter & solar storage, maintenance-free, spill-proof',
    verified: true,
    datasheetUrl:
      'https://www.babattery.co.za/products/ba-gel-deep-cycle-12v-battery-100-ah-12-month-warranty',
    specs: {
      voltage: 12,
      capacityAh: 100,
      chemistry: 'gel',
      use: 'ups-replacement',
    },
  },
  {
    id: 'ba-gel-deep-cycle-150ah-12v',
    manufacturer: 'BA Battery',
    model: 'BA Gel Deep Cycle 150Ah 12V',
    category: 'battery',
    tagline: '12 V 150 Ah gel deep-cycle — UPS, inverter & solar storage, maintenance-free, spill-proof',
    verified: true,
    datasheetUrl:
      'https://www.babattery.co.za/products/ba-gel-deep-cycle-12v-battery-150-ah-12-month-warranty',
    specs: {
      voltage: 12,
      capacityAh: 150,
      chemistry: 'gel',
      use: 'ups-replacement',
    },
  },
  {
    id: 'ba-gel-deep-cycle-200ah-12v',
    manufacturer: 'BA Battery',
    model: 'BA Gel Deep Cycle 200Ah 12V',
    category: 'battery',
    tagline: '12 V 200 Ah gel deep-cycle — UPS, inverter & solar storage, maintenance-free, spill-proof',
    verified: true,
    datasheetUrl:
      'https://www.babattery.co.za/products/ba-gel-deep-cycle-12v-battery-200-ah-12-month-warranty',
    specs: {
      voltage: 12,
      capacityAh: 200,
      chemistry: 'gel',
      use: 'ups-replacement',
    },
  },
  {
    id: 'ba-lithium-deep-cycle-50ah-12v',
    manufacturer: 'BA Battery',
    model: 'BA Lithium Deep Cycle 50Ah 12V',
    category: 'battery',
    tagline: '12 V 50 Ah LiFePO4 deep-cycle — UPS/inverter/solar, lightweight, long cycle life',
    verified: true,
    datasheetUrl:
      'https://www.babattery.co.za/products/ba-lithium-deep-cycle-12v-battery-50-ah-12-month-warranty',
    specs: {
      voltage: 12,
      capacityAh: 50,
      chemistry: 'lifepo4',
      use: 'ups-replacement',
    },
  },
  {
    id: 'ba-lithium-deep-cycle-100ah-12v',
    manufacturer: 'BA Battery',
    model: 'BA Lithium Deep Cycle 100Ah 12V',
    category: 'battery',
    tagline: '12 V 100 Ah LiFePO4 deep-cycle — UPS/inverter/solar, lightweight, long cycle life',
    verified: true,
    datasheetUrl:
      'https://www.babattery.co.za/products/ba-lithium-deep-cycle-12v-battery-100-ah-12-month-warranty',
    specs: {
      voltage: 12,
      capacityAh: 100,
      chemistry: 'lifepo4',
      use: 'ups-replacement',
    },
  },
  {
    id: 'ba-lithium-deep-cycle-200ah-12v',
    manufacturer: 'BA Battery',
    model: 'BA Lithium Deep Cycle 200Ah 12V',
    category: 'battery',
    tagline: '12 V 200 Ah LiFePO4 deep-cycle — UPS/inverter/solar, lightweight, long cycle life',
    verified: true,
    datasheetUrl:
      'https://www.babattery.co.za/products/ba-lithium-deep-cycle-12v-battery-200-ah-12-month-warranty',
    specs: {
      voltage: 12,
      capacityAh: 200,
      chemistry: 'lifepo4',
      use: 'ups-replacement',
    },
  },
];
